<template>
  <aside id="room-overlay" @click="close">
      <h1>{{ $route.params.room }}</h1>
  </aside>
</template>

<script>
export default {
    name: 'RoomOverlay',
    props: {
        room: String
    },
    methods: {
        close(){
            this.$store.commit('toggleRoomOverlay');
        }
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#room-overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.9);
    top: 0;
    left: 0;
    @include center;

    &:hover {
        cursor: pointer;
    }

    h1 {
        font-size: 15vw;
        margin: 0;
        padding: 2vw 6vw;
        color: white;
        border: 1.5vw solid white;
        border-radius: 2rem;
        letter-spacing: 1rem;
    }
}
</style>